import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import React, { FC } from "react";
import { RefreshButton } from "../../atoms/RefreshButton";
import { useTranslation } from "react-i18next";

interface SearchProps {
  search: string;
  setSearch: (arg: string) => void;
  handleOpenModal: () => void;
  addButtonText: string;
  refetch: () => void;
}

export const Search: FC<SearchProps> = ({
  search,
  setSearch,
  handleOpenModal,
  addButtonText,
  refetch,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{ display: "flex", padding: { xs: "12px", sm: "12px", md: "24px" } }}
    >
      <Button
        variant="contained"
        size="small"
        startIcon={<AddIcon />}
        sx={{
          mr: "8px",
          minWidth: { xs: "none", sm: "none", md: "140px" },
          boxShadow: "none",
          borderRadius: "12px",
          whiteSpace: "nowrap",
          display: "flex",
          justifyContent: "center",
        }}
        onClick={handleOpenModal}
      >
        <Typography sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
          {addButtonText}
        </Typography>
        <Typography sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
          {t("Add")}
        </Typography>
      </Button>
      <TextField
        placeholder={t("Search")}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, mr: "4px" }}
      ></TextField>
      <RefreshButton refetch={refetch} />
    </Box>
  );
};
